import React, { useEffect, useMemo, useState } from "react";

import mapbox from "../mapbox";
import { View } from "react-native";
import "./index.web.css";
const flyTo = (map) => (center) => {
  map.flyTo({
    center,
    speed: 5,
    zoom: 16,
    curve: 1,
  });
};

const MapView = ({
  camera,
  props,
  onMapIdle,
  onLoad,
  onDidFinishLoadingMap,
  container = "maps",
}) => {
  const [map, setMap] = useState(null);

  const memoizedCamera = useMemo(() => camera, [JSON.stringify(camera)]);

  useEffect(() => {
    const newMap = new (mapbox as any).Map({
      container: container,
      style: "mapbox://styles/mapbox/streets-v12",
      ...props,
      ...camera,
    });
    newMap.on("dragend", () => {
      const center = newMap.getCenter();
      onMapIdle({
        properties: {
          center: [center.lng, center.lat],
        },
      });
    });
    newMap.on("load", function () {
      onDidFinishLoadingMap && onDidFinishLoadingMap();
    });
    setMap(newMap);
    onLoad(newMap);
    return () => {
      newMap.remove();
    };
  }, []);

  useEffect(() => {
    if (map) {
      map.flyTo({
        ...memoizedCamera,
        speed: 1,
        curve: 0,
        easing: (t) => t,
        essential: true,
      });
    }
  }, [memoizedCamera]);

  return (
    <View
      id={container}
      style={{ flex: 1, width: "100%", height: "100%" }}
    ></View>
  );
};

const Camera = { flyTo };

export { MapView, Camera, flyTo };
